import * as React from "react";
import Icon from "@ant-design/icons";

import { ChartType } from "@ctra/api";

import { ReactComponent as Bar } from "./svg/bar.svg";
import { ReactComponent as StackedColumn } from "./svg/column-stacked.svg";
import { ReactComponent as StackedColumn100 } from "./svg/column-stacked-100.svg";
import { ReactComponent as Heatmap } from "./svg/heatmap.svg";
import { ReactComponent as Line } from "./svg/line.svg";
import { ReactComponent as Table } from "./svg/table.svg";

export const chartViewIconMap: Record<ChartType, typeof StackedColumn> = {
  basicBar: Bar,
  heatmap: Heatmap,
  basicLine: Line,
  stackedColumn: StackedColumn,
  groupedColumn: Bar,
  stackedPercentColumn: StackedColumn100,
  table: Table
};

export type ChartViewIconProps = React.ComponentProps<typeof Icon> & {
  /**
   * chart view
   */
  view: ChartType;
};

/**
 * Custom chart view icons for Mongo Charts
 */
const ChartViewIcon: React.FC<ChartViewIconProps> = ({ view, ...rest }) => {
  return <Icon component={chartViewIconMap[view]} {...rest} />;
};

export default ChartViewIcon;
